import { Box } from "@mui/system";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { createSearchParams, useLocation, useNavigate } from "react-router-dom";
import { allFilters } from "../../redux/actions/filterActions";
import { CloseIcon } from "../Icon/MuiIcons";
import { styles } from "./styles";
import IconComponent from "../Icon/IconComponent";
import { ICON_LABELS, fontSize, fontWeight } from "../../utils/constants/UI";
import { BRAND, GREY } from "../../utils/constants/colors";
import TypographyInline from "../Typography/TypographyInline";
import { STRINGS } from "../strings";

const EmailVerificationDateFilter = ({
  filter,
  type = "",
  minDate,
  maxDate,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const allFiltersSelector = useSelector((state) => state.allFilters?.payload);

  const handleRemoveFilter = () => {
    const query = JSON.parse(JSON.stringify(allFiltersSelector));
    delete query?.e_verify_min_date;
    delete query?.e_verify_max_date;

    dispatch(allFilters(query, true));
    navigate({
      pathname: location.pathname,
      search: createSearchParams({
        ...query,
      }).toString(),
    });
  };

  return (
    <Box sx={styles.selectedFilterBox}>
      <div style={styles.cancelIcon} onClick={handleRemoveFilter}>
        <IconComponent
          iconLabel={ICON_LABELS.CANCEL}
          color={GREY.TERTIARY}
          fontSize={fontSize.MD}
        />
      </div>
      <div style={styles.filterValues}>
        <TypographyInline
          label={filter}
          size={"sm"}
          fontWeight={fontWeight.SEMIBOLD}
          color={GREY.PRIMARY}
          isNoWrap={true}
        />
        <TypographyInline
          label={
            type === "_not" ? STRINGS.IS_NOT_EQUAL_TO : STRINGS.IS_EQUAL_TO
          }
          size={"sm"}
          fontWeight={fontWeight.REGULAR}
          color={GREY.SECONDARY}
          isNoWrap={true}
        />
        <TypographyInline
          label={`${minDate} and ${maxDate}`}
          size={"sm"}
          fontWeight={fontWeight.REGULAR}
          color={BRAND.PRIMARY}
          isNoWrap={true}
        />
      </div>
    </Box>
  );
};

export default EmailVerificationDateFilter;
